import { Trans } from '@lingui/macro';
import { ActionIcon, Stack } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'tabler-icons-react';

import { UiCard } from '../../components/ui/ui-card/ui-card';
import { MainSideMenu } from '../../features/main-side-menu/main-side-menu';
import { routeCabinet } from '../../router/routes';
import { PushNotifySettings } from './push-notify-settings';

// import { PushNotifySettings } from './push-notify-settings';

import styles from './push-notify.page.module.css';

export const PushNotifyPage = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <div className={styles.backButton}>
          <ActionIcon
            variant="transparent"
            radius="50%"
            size="40px"
            bg="transparent"
            onClick={() => navigate(routeCabinet.path)}
          >
            <ArrowLeft size={24} strokeWidth={2} color="white" />
          </ActionIcon>
        </div>
        <div className={styles.routeTitle}>
          <h1 className={styles.headerTitle}>
            <Trans>Уведомления</Trans>
          </h1>
        </div>
        <div className={styles.mainSideMenu}>
          <MainSideMenu />
        </div>
      </header>
      <main className={styles.main}>
        <Stack spacing="md">
          <UiCard
            title={
              <b>
                <Trans>Настройка уведомлений</Trans>
              </b>
            }
          >
            <PushNotifySettings />
          </UiCard>
        </Stack>
      </main>
    </div>
  );
};
